import {
  findCurrentAgencies,
  findCurrentBatchLabel,
} from "../report/reportActions";

export const transformProductionInput = (values, taskKey) => (state) => {
  const agency = findCurrentAgencies(state, values.AgencyKeys);
  const batchFromLabel = findCurrentBatchLabel(state, values.BatchNumberFrom);
  const batchToLabel = findCurrentBatchLabel(state, values.BatchNumberTo);
  const transactionDates = [
    values.TransactionDate[0],
    values.TransactionDate[1],
  ];
  return {
    ...values,
    ProducersTaskKey: taskKey,
    AgencyNameAndNumber: agency.FullName,
    BatchFromLabel: batchFromLabel,
    BatchToLabel: batchToLabel,
    TransactionDate: transactionDates,
    FileName: `Production${values.ReportType}_${agency.Number}`,
  };
};
